import { DEMO_USER_DEFINITIONS } from "@shared/platform/demo-fixture-data";
import {
  ORDER_PRICE_FILTER_ERRORS, orderPriceFilterAccessError, parseOrderPriceFilter,
  selectOrdersByPriceFilter, type OrderPriceFacts,
} from "@shared/orders/order-price-filter";

export function demoOrderPriceResponse<T extends OrderPriceFacts>(url: URL, orders: readonly T[]) {
  const parsed = parseOrderPriceFilter(url.searchParams);
  if (!parsed.success) return { status: 400, body: { message: ORDER_PRICE_FILTER_ERRORS.invalid } };
  const error = orderPriceFilterAccessError(parsed.data, DEMO_USER_DEFINITIONS.admin.role);
  if (error) return { status: error.status, body: { message: error.message } };
  return { status: 200, body: selectOrdersByPriceFilter(orders, parsed.data) };
}
